import { render, staticRenderFns } from "./three.vue?vue&type=template&id=52b2c789&scoped=true&"
import script from "./three.vue?vue&type=script&lang=js&"
export * from "./three.vue?vue&type=script&lang=js&"
import style0 from "./three.vue?vue&type=style&index=0&id=52b2c789&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b2c789",
  null
  
)

export default component.exports